import gql from 'graphql-tag';

export const GET_CONTACTS = gql`
  query contacts($zip: Zip!, $city: String!, $district: String!, $tile: Tile!) {
    contacts(zip: $zip, city: $city, district: $district, tile: $tile) {
      email
      phoneNumberCall
      phoneNumberDisplay
      type
      marker
      location {
        salesOffice
      }
    }
  }
`;

export const GET_INCIDENTS = gql`
  {
    incidents {
      zip
      city
      district
      street
      dateCreated
    }
  }
`;

export const GET_EVENTS_OVERVIEW_DATA_QUERY = gql`
  query {
    events(top: 5) {
      id
      startDate
      endDate
      registrationDeadline
      tags
      creationDate
      title
      path
    }
  }
`;

export const GET_ARTICLES_OVERVIEW_DATA_QUERY = gql`
  query {
    articles(top: 5) {
      id
      creationDate
      tags
      title
      description
      shortDescription
      path
    }
  }
`;

export const getAllEventsQuery = gql`
  query {
    events {
      id
      path
      startDate
      endDate
      title
      description
      location {
        description
        street
        streetNumber
        zip
        city
      }
      registrationDeadline
      tags
      attachmentUrl
      disableMaxParticipation
      allowGuestRegistration
      maxParticipants
      maxParticipantsPerCompany
      registration {
        eventParticipantsNumber
        participants {
          id
          firstName
          lastName
          eMail
          fachkraftId
          installerEmail
        }
      }
      attachmentUrl
      eventDays {
        date
        startTime
        endTime
      }
    }
  }
`;

export const GET_EVENT_BY_AEMID = gql`
  query ($aemId: String!) {
    event(aemId: $aemId) {
      id
      path
      creationDate
      startDate
      endDate
      title
      description
      chargingAmount
      chargingNote
      requiredQRCode
      noKIDUsersAllowed
      location {
        description
        street
        streetNumber
        zip
        city
      }
      registrationDeadline
      tags
      attachmentUrl
      meetingLink
      disableMaxParticipation
      allowGuestRegistration
      maxParticipants
      maxParticipantsPerCompany
      registration {
        eventParticipantsNumber
        participants {
          id
          firstName
          lastName
          eMail
          fachkraftId
          installerEmail
        }
      }
      attachmentUrl
      eventDays {
        date
        startTime
        endTime
      }
    }
  }
`;

export const GET_ARTICLES_QUERY = gql`
  query (
    $searchCriteria: ArticlesSearchCriteria
    $action: PaginationAction!
    $cursor: LocalDateTime
    $limit: Int!
    $page: Int!
  ) {
    articles(
      searchCriteria: $searchCriteria
      pagination: { action: $action, cursor: $cursor, limit: $limit, page: $page }
    ) {
      likes
      id
      creationDate
      tags
      title
      description
      shortDescription
      path
      enableFeedback
    }
  }
`;

export const GET_TOTAL_ARTICLE_PAGES_QUERY = gql`
  query ($searchCriteria: ArticlesSearchCriteria, $limit: Int!) {
    articlesPagesNumber(searchCriteria: $searchCriteria, limit: $limit)
  }
`;

export const GET_EVENT_QUERY = gql`
  query (
    $searchCriteria: EventsSearchCriteria
    $action: PaginationAction!
    $cursor: LocalDateTime
    $limit: Int!
  ) {
    events(
      searchCriteria: $searchCriteria
      pagination: { action: $action, cursor: $cursor, limit: $limit }
    ) {
      creationDate
      id
      path
      startDate
      endDate
      title
      description
      chargingAmount
      requiredQRCode
      location {
        description
        street
        streetNumber
        zip
        city
      }
      tags
      attachmentUrl
      meetingLink
      disableMaxParticipation
      maxParticipants
      maxParticipantsPerCompany
      registrationDeadline
      registration {
        participants {
          id
        }
        eventParticipantsNumber
      }
      attachmentUrl
      eventDays {
        date
        startTime
        endTime
      }
    }
  }
`;

export const GET_PAST_EVENTS_QUERY = gql`
  query {
    pastEvents {
      creationDate
      id
      path
      startDate
      endDate
      title
      description
      location {
        description
        street
        streetNumber
        zip
        city
      }
      tags
      attachmentUrl
      meetingLink
      requiredQRCode
      disableMaxParticipation
      maxParticipants
      maxParticipantsPerCompany
      registrationDeadline
      chargingAmount
      registration {
        participants {
          id
        }
        eventParticipantsNumber
      }
      attachmentUrl
      eventDays {
        date
        startTime
        endTime
      }
    }
  }
`;

export const GET_TOTAL_EVENT_PAGES_QUERY = gql`
  query ($searchCriteria: EventsSearchCriteria, $limit: Int!) {
    eventsPagesNumber(searchCriteria: $searchCriteria, limit: $limit)
  }
`;

export const GET_USER_EVENTS_QUERY = gql`
  query {
    myRegisteredEvents {
      id
      path
      startDate
      endDate
      title
      meetingLink
      deleted
      chargingAmount
      eventDays {
        date
        startTime
        endTime
      }
      registration {
        participants {
          id
        }
      }
    }
  }
`;

export const CONTACT_EXPERT_QUERY = gql`
  query ($mailInput: MailInput!) {
    contactExpert(mail: $mailInput) {
      status
    }
  }
`;

export const USER_STATUS_QUERY = gql`
  query {
    userStatus {
      notifications {
        articles
        events
      }
      subscription
      role
      iamType
      id
      installerEmail
      latestDebFormRequestDate
      fullName
    }
  }
`;

export const SUBSCRIPTION_STATUS_QUERY = gql`
  query {
    userStatus {
      subscription
    }
  }
`;

export const GET_LOCATIONS_QUERY = gql`
  query locations($zip: Zip!, $tile: Tile!) {
    locations(zip: $zip, tile: $tile) {
      city
      district
    }
  }
`;

export const GET_INSTALLERID_QUERY = gql`
  query installerId($installerIdInput: InstallerIdInput!) {
    installerId(installerIdInput: $installerIdInput) {
      base64
    }
  }
`;

export const GET_INSTALLER_QUERY = gql`
  query getInstaller {
    getInstaller {
      id
      firmenname1
      firmenname2
      firmenname3
      firmeninhaber
      email
      telefonGeschaeft
      telefonMobil
      fax
      bEintragungAls {
        id
        name
      }
      bEintragungGasAls {
        id
        name
      }
      zaehlermontageStrom
      zaehlermontageGas
      bueroStrasse
      bueroHausnummer
      bueroPlz
      bueroOrt
      bueroOrtsteil
      bueroLand
      referenznummerStrom
      zuAdressveroeff
      zuInfoversand
      informationOperators
      addressOperators
      eintragungsartStrom
      eintragungsartGas
      bBetriebsartStrom {
        name
      }
      bBetriebsartGas {
        name
      }
      statusStrom
      statusGas
      auswStromGueltig
      auswGasGueltig
      auswStromDatum
      auswGasDatum
      eintragungsartErgStrom
      eintragungsartErgGas
      gewerbeanmeldungOrt
      gewerbeanmeldungDatum
      hrabnummer
      hwknummer
      hwkdatum
      pflegendeBu
      registergericht
      registerLetzteAenderung
      geloeschtAm
      geloeschtGasAm
      geloeschtWasserAm
      ausweisnrFremdStrom
      ausweisnrFremdGas
      eintragungsartErgGas
      eintragungsartErgStrom
      bNetzbetreiberGas {
        id
        name
      }
      bNetzbetreiberStrom {
        id
        name
      }
      bHwkbereich {
        name
        id
      }
    }
  }
`;

export const GET_INSTALLER_EXPERTS_QUERY = gql`
  query getInstallerExperts {
    getInstallerExperts {
      id
      egcid
      geburtsdatum
      gueltigBisGas
      gueltigBisStrom
      gueltigBisWasser
      hwkBetriebsleiter
      bBerufbezStromId
      bBerufbezGasId
      bFachrichtungStromId
      bFachrichtungGasId
      bZusatzStromId
      bZusatzGasId
      nachname
      telefon
      netzportalEmail
      consentAdressveroeff
      consentInfoversand
      informationOperators
      salesForceStatus
      statusGas
      statusStrom
      statusWasser
      vorname
    }
  }
`;

export const GET_INSTALLER_CONTRACTS_QUERY = gql`
  query getInstallerContracts {
    getInstallerContracts {
      id
      vertragsart {
        name
        id
      }
      vertragsstatus
      abgeschlossenAm
      beendetAm
    }
  }
`;

export const GET_INSTALLER_SEALS_QUERY = gql`
  query getInstallerSeals {
    getInstallerSeals {
      id
      zangennr
      status {
        name
      }
      ausgegebenAm
      zurueckgegebenAm
      verlustAm
    }
  }
`;
export const GET_MY_TASKS_QUERY = gql`
  query getInstallerAntraege {
    getInstallerAntraege {
      antragstatus
      antragtyp
      antragsubtyp
      eingangsdatum
      id
    }
  }
`;
export const GET_ENRICHED_EVENT_PARTICIPANTS_BY_ID_QUERY = gql`
  query getEnrichedEventParticipants($eventId: Int!) {
    getEnrichedEventParticipants(eventId: $eventId) {
      id
      allParticipants {
        companyName
        installerId
        participants {
          id
          firstName
          lastName
          eMail
          installerEmail
        }
      }
    }
  }
`;

// PUBLIC queries which need no authentication config (see Apollo.jsx)

export const PUBLIC_GET_CIAM_STATUS_BY_EMAIL = gql`
  query GetCiamStatusByEmail($email: String!) {
    getCiamStatusByEmail(email: $email) {
      ciamStatus
      statusStrom
      statusGas
      status
    }
  }
`;
export const PUBLIC_GET_GRIDNET_PROVIDERS_QUERY = gql`
  query getGridNetProviders {
    getGridNetProviders {
      id
      name
      ort
      plz
      strasse
      netzbetreibernummer
      eintragungsart
      geloescht
    }
  }
`;

export const PUBLIC_GET_CRAFTCHAMBERS_QUERY = gql`
  query getCraftChamberAreas {
    getCraftChamberAreas {
      geloescht
      id
      name
    }
  }
`;

export const PUBLIC_GET_BETRIEBSARTEN_QUERY = gql`
  query getBetriebsarten {
    getBetriebsarten {
      id
      name
      pflegendeBu
      geloescht
    }
  }
`;
// LOKAREF
export const SEARCH_LOKAREF_CITIES = gql`
  query SearchLokaRefCities($input: LokaRefCitySearchInput!) {
    searchLokaRefCities(input: $input) {
      cityId
      name
      state
      postcodes {
        postcodeId
        postcode
      }
    }
  }
`;

export const SEARCH_LOKAREF_STREETS = gql`
  query SearchStreets($input: LokaRefStreetSearchInput!) {
    searchLokaRefStreets(input: $input) {
      streetId
      name
      cityName
      districts {
        districtId
        postcode
        district
      }
    }
  }
`;

export const GET_TASK_DETAIL_QUERY = gql`
  query GetAntragDetail($antragId: Long!) {
    getInstallerAntragDetail(antragId: $antragId) {
      id
      antragtyp
      antragsubtyp
      antragstatus
      eingangsdatum
      messages {
        id
        message
        sender
        kid
        timestamp
        fields {
          id
          intent
          entity
          entityId
          field
          value
        }
        files {
          id
          intent
          documentType
          file {
            id
            filename
            extension
            deleted
            deletedAt
            uploadedAt
            kid
          }
        }
        attachments {
          id
          file {
            id
            filename
            extension
            deleted
            deletedAt
            uploadedAt
            kid
            downloadUrl
          }
        }
      }
    }
  }
`;

export const SEARCH_LOKAREF_HOUSE_NUMBERS = gql`
  query SearchLokaRefHouseNumbers($input: LokaRefHouseNumberSearchInput!) {
    searchLokaRefHouseNumbers(input: $input) {
      housenrId
      number
      addon
      latitude
      longitude
    }
  }
`;
